import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinhadapsar() {



const cardData = {
  keyword: "Taxi Service in Hadapsar",
  heading: "Lotus Cab: Taxi Service in Hadapsar",

  headingDescription:
    "Lotus Cab provides reliable, affordable, and professional Taxi Service in Hadapsar designed to meet daily commuting, airport transfers, corporate travel, family trips, and outstation journey requirements. Hadapsar is one of Pune’s busiest residential and IT hubs with major locations like Magarpatta City, Amanora Park Town, SP Infocity, and numerous commercial complexes. Whether you need a punctual airport pickup, AC sedan for business meetings, SUV for family travel, or mini bus for group transportation, we offer well-maintained and chauffeur-driven vehicles for every need. Our fleet includes AC sedans, spacious SUVs, luxury cars, and mini buses with transparent per-kilometer pricing and zero hidden charges. All vehicles are GPS-enabled, sanitized, and regularly serviced to ensure safe and smooth travel across city and highway routes. Our drivers are background-verified, trained for professional behavior, and experienced in navigating traffic-heavy areas of Hadapsar. With instant online booking, flexible one-way and round-trip packages, and 24/7 customer support, Lotus Cab guarantees comfortable, punctual, and stress-free cab service in Hadapsar for every travel requirement.",

  top: "Top Places to Visit in Pune from Hadapsar with Lotus Cab",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most iconic historical landmarks and attracts tourists throughout the year. Located in the heart of the city, it reflects the rich Maratha heritage and architectural brilliance. Booking a taxi from Hadapsar ensures convenient pickup and smooth access to central Pune. Our AC sedans provide comfortable city travel even during peak traffic hours. Families and tourists prefer SUV options for added space and comfort. Flexible waiting time allows relaxed sightseeing without rush. Lotus Cab ensures safe navigation through busy city roads. Ideal for heritage and cultural exploration trips."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a peaceful historical monument associated with India’s freedom movement. Surrounded by beautiful gardens, it is perfect for family visits and educational tours. Taxi service from Hadapsar ensures quick connectivity to this landmark. AC vehicles provide comfort during warm weather. Professional drivers ensure punctual arrival and safe return. Ideal for short city sightseeing trips. Lotus Cab guarantees relaxed and convenient travel."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular weekend destination near Pune offering scenic views and historical importance. SUV cabs from Hadapsar are ideal for ghat road travel. Spacious seating ensures comfortable uphill journeys. Families prefer round-trip packages for convenience. Safe and experienced drivers manage hill routes efficiently. Perfect for weekend getaways."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "A peaceful picnic destination ideal for families and friends. Taxi service from Hadapsar provides comfortable round-trip travel. AC sedans and SUVs ensure relaxed highway experience. Ideal for evening outings."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a favorite weekend getaway near Pune. Booking an outstation cab from Hadapsar ensures smooth expressway travel. SUV and sedan options provide comfortable highway driving. Ideal for family and corporate trips."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a scenic hill station popular for nature and strawberry farms. Outstation cab from Hadapsar offers relaxed long-distance travel. AC comfort enhances journey experience."
    },
    {
      title: "Pune Airport",
      description:
        "Reliable airport pickup and drop service from Hadapsar ensures timely arrival for domestic and international flights. Our chauffeurs track flight timings for punctual service."
    },
    {
      title: "Magarpatta City",
      description:
        "Major IT and commercial hub in Hadapsar where corporate cab services are frequently required. Professional drivers ensure punctual office transfers."
    }
  ],

  services: [
    {
      name: "Hadapsar Taxi Service",
      description:
        "Our Hadapsar taxi service provides reliable transportation for daily commuting, office travel, and city tours. Customers can choose from AC sedans, SUVs, luxury cars, and mini buses based on their travel requirements. Vehicles are regularly maintained and sanitized for safety and comfort. Professional chauffeurs ensure disciplined driving and punctual arrival. Transparent pricing eliminates hidden costs. Ideal for individuals, families, and corporate employees. 24/7 booking support ensures hassle-free reservations. Lotus Cab guarantees smooth travel within Hadapsar and beyond."
    },
    {
      name: "AC Cab Hadapsar",
      description:
        "Fully air-conditioned cabs available for comfortable travel during all seasons. AC sedans are perfect for daily office rides and airport transfers. Spacious interiors ensure relaxed seating. Clean and sanitized vehicles enhance travel experience. Professional drivers ensure safe and punctual service. Ideal for summer travel comfort."
    },
    {
      name: "SUV Cab Hadapsar",
      description:
        "Spacious SUV taxis suitable for family travel and group outings. Comfortable seating and luggage capacity make long-distance travel convenient. Ideal for outstation trips and corporate bookings."
    },
    {
      name: "Luxury Cab Hadapsar",
      description:
        "Premium luxury vehicles available for executive meetings, VIP travel, and special occasions. Elegant interiors and professional chauffeurs ensure premium experience."
    },
    {
      name: "Airport Pickup Hadapsar",
      description:
        "Timely airport pickup service with flight tracking support. Drivers ensure on-time arrival and luggage assistance."
    },
    {
      name: "Outstation Cab Hadapsar",
      description:
        "Comfortable long-distance travel options from Hadapsar to Mumbai, Nashik, Mahabaleshwar, and other destinations."
    },
    {
      name: "Corporate Cab Hadapsar",
      description:
        "Reliable corporate transportation solutions for IT parks, offices, and business meetings."
    },
    {
      name: "Online Cab Booking Hadapsar",
      description:
        "Instant online booking with transparent pricing and 24/7 customer assistance."
    }
  ],

  tableData: [
    ["Hadapsar Taxi Service", "AC Cab Hadapsar"],
    ["Sedan Cab Hadapsar", "SUV Cab Hadapsar"],
    ["Luxury Cab Hadapsar", "Corporate Cab Hadapsar"],
    ["Family Trip Cab Hadapsar", "Airport Pickup Hadapsar"],
    ["Airport Drop Hadapsar", "Online Cab Booking Hadapsar"],
    ["One Way Cab Hadapsar", "Round Trip Cab Hadapsar"],
    ["Mini Bus Hadapsar", "Chauffeur Driven Cab Hadapsar"],
    ["Budget Cab Hadapsar", "Same Day Cab Hadapsar"],
    ["Outstation Cab Hadapsar", "Per Km Rate Cab Hadapsar"],
    ["Weekend Trip Cab Hadapsar", "Best Cab Service Hadapsar"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Punctual Service",
      WhyChoosedescription:
        "We ensure on-time pickup and drop for airport transfers, office rides, and outstation trips."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per-kilometer fare structure without hidden charges."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription:
        "Background-verified and experienced chauffeurs ensure safe travel."
    },
    {
      WhyChooseheading: "Wide Fleet Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury cars, and mini buses available."
    },
    {
      WhyChooseheading: "Clean & Sanitized Vehicles",
      WhyChoosedescription:
        "Regular cleaning and vehicle maintenance for safety."
    },
    {
      WhyChooseheading: "Corporate Solutions",
      WhyChoosedescription:
        "Dedicated cab services for IT companies and business clients."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock assistance for booking and travel queries."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and hourly rental packages available."
    }
  ]
};

const faqData = [
  {
    question: "Do you provide airport pickup from Hadapsar?",
    answer:
      "Yes, we provide reliable airport pickup and drop service from Hadapsar with flight tracking support."
  },
  {
    question: "Is AC available in all vehicles?",
    answer:
      "Yes, all our vehicles are fully air-conditioned for comfortable travel."
  },
  {
    question: "Is online booking available?",
    answer:
      "Yes, customers can book instantly online with transparent fare details."
  },
  {
    question: "Do you offer outstation travel?",
    answer:
      "Yes, we provide outstation cab services from Hadapsar to major cities."
  },
  {
    question: "Are drivers verified?",
    answer:
      "Yes, all chauffeurs are background-verified and professionally trained."
  },
  {
    question: "Is per km pricing transparent?",
    answer:
      "Yes, we provide upfront fare breakdown before booking confirmation."
  },
  {
    question: "Are SUVs available?",
    answer:
      "Yes, spacious SUVs are available for family and group travel."
  },
  {
    question: "Is mini bus service available?",
    answer:
      "Yes, mini bus options are available for group bookings."
  },
  {
    question: "Is 24/7 support available?",
    answer:
      "Yes, our support team is available round-the-clock."
  },
  {
    question: "Do you provide corporate cab service?",
    answer:
      "Yes, we offer dedicated corporate travel solutions in Hadapsar."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback:
      "Excellent taxi service in Hadapsar. Very punctual airport pickup and clean vehicle. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Booked SUV for family trip. Comfortable ride and professional driver.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable cab service for office transportation. Transparent billing and punctual service.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Prakash Jain",
    feedback:
      "Used outstation cab from Hadapsar. Smooth highway driving and fair pricing.",
    rating: 5
  },
  {
    id: 5,
    name: "Mrs. Meera Patil",
    feedback:
      "Very convenient online booking and quick confirmation. Great experience.",
    rating: 5
  }
];



































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Hadapsar",
  "image": "https://lotuscab.com/assets/images/hadapsar-cab.jpg",
  "description": "Book reliable Taxi Service in Hadapsar with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for one-way, round trips, family trips, corporate travel, airport transfers, weekend trips, and outstation trips. Affordable per km rates and same-day options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "150",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/hadapsar-taxi-service"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Taxi Service in Hadapsar | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book reliable Taxi Service in Hadapsar with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for one-way, round trips, family trips, corporate travel, airport transfers, weekend & outstation trips. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Hadapsar Taxi Service, AC Cab Hadapsar, Sedan Cab Hadapsar, SUV Cab Hadapsar, Luxury Cab Hadapsar, Corporate Cab Hadapsar, Family Trip Cab Hadapsar, Airport Pickup Hadapsar, Airport Drop Hadapsar, Online Cab Booking Hadapsar, One Way Cab Hadapsar, Round Trip Cab Hadapsar, Mini Bus Hadapsar, Chauffeur Driven Cab Hadapsar, Budget Cab Hadapsar, Same Day Cab Hadapsar, Outstation Cab Hadapsar, Per Km Rate Cab Hadapsar, Weekend Trip Cab Hadapsar, Best Cab Service Hadapsar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinhadapsar;